/**
 * 시스템 및 디버그 관련 API
 */

import { apiCall } from "./base";

/**
 * 기본 헬스 체크
 */
export const getHealth = async (): Promise<unknown> => {
  return await apiCall("/");
};

/**
 * 아이템 조회
 */
export const getItem = async (itemId: string): Promise<unknown> => {
  return await apiCall(`/items/${itemId}`);
};

/**
 * 서버 상태 조회 (파일 변환 서버 및 Unity VM 상태)
 */
export const getServerStatus = async (
  userToken: string | null
): Promise<unknown> => {
  const options: RequestInit = {
    method: "GET",
    headers: {
      Authorization: userToken ? `Bearer ${userToken}` : "",
    },
  };

  return await apiCall("/server-status", options);
};

/**
 * 사용자 정보 검증 디버깅
 */
export const debugValidateUser = async (
  userInfo: unknown
): Promise<unknown> => {
  const options: RequestInit = {
    method: "POST",
    body: JSON.stringify(userInfo),
    headers: {
      "Content-Type": "application/json",
    },
  };

  return await apiCall("/debug/validate-user", options);
};

/**
 * 원시 데이터 디버깅
 */
export const debugRawData = async (userInfo: unknown): Promise<unknown> => {
  const options: RequestInit = {
    method: "POST",
    body: JSON.stringify(userInfo),
    headers: {
      "Content-Type": "application/json",
    },
  };

  return await apiCall("/debug/raw-data", options);
};

/**
 * 데이터베이스 연결 테스트
 */
export const testDatabaseConnection = async (): Promise<unknown> => {
  return await apiCall("/db/test");
};

/**
 * 테스트용 사용자 정보 저장 (Firebase 토큰 없이)
 */
export const saveUserInfoTest = async (
  userInfo: unknown
): Promise<unknown> => {
  const options: RequestInit = {
    method: "POST",
    body: JSON.stringify(userInfo),
    headers: {
      "Content-Type": "application/json",
    },
  };

  return await apiCall("/users/save-test", options);
};

/**
 * 파일 저장 테스트 (임시)
 */
export const saveUserInfoToFile = async (
  userInfo: unknown,
  userToken: string | null
): Promise<unknown> => {
  const options: RequestInit = {
    method: "POST",
    body: JSON.stringify(userInfo),
    headers: {
      Authorization: userToken ? `Bearer ${userToken}` : "",
      "Content-Type": "application/json",
    },
  };

  return await apiCall("/users/save-file", options);
};

/**
 * Compute Engine Health 체크
 */
export const callComputeEngineHealth = async (): Promise<unknown> => {
  // 백엔드 실제 경로는 /compute/health
  return await apiCall("/compute/health");
};

/**
 * Compute Engine Echo 테스트
 */
export const callComputeEngineEcho = async (
  message = "Hello from React!"
): Promise<unknown> => {
  const options: RequestInit = {
    method: "POST",
    body: JSON.stringify({ input_message: message }),
    headers: {
      "Content-Type": "application/json",
    },
  };

  // 백엔드 실제 경로는 /compute/echo
  return await apiCall("/compute/echo", options);
};

/**
 * 테스트용 Compute Engine API 함수들 (실제 CE 연결 없이 테스트 가능)
 */
export const testComputeEngineHealth = async (): Promise<unknown> => {
  return await apiCall("/test-ce-health");
};

/**
 * 테스트용 Compute Engine Echo
 */
export const testComputeEngineEcho = async (
  message = "Hello from React!"
): Promise<unknown> => {
  const options: RequestInit = {
    method: "POST",
    body: JSON.stringify({ input_message: message }),
    headers: {
      "Content-Type": "application/json",
    },
  };

  return await apiCall("/test-ce-echo", options);
};

/**
 * 환경 변수 디버깅
 */
export const debugEnvironment = async (): Promise<unknown> => {
  return await apiCall("/debug/env");
};

/**
 * Unity 연결 테스트
 */
export const testUnityConnection = async (
  userToken: string | null
): Promise<unknown> => {
  const options: RequestInit = {
    method: "GET",
    headers: {
      Authorization: userToken ? `Bearer ${userToken}` : "",
      "Content-Type": "application/json",
    },
  };
  return await apiCall("/test-unity-connection", options);
};

